import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import FJVideoRemovePreviewBox from '../view/FJVideoRemovePreviewBox';
import { useSelector } from 'react-redux';
import FJConstant from '../../../../constants/FJConstant';

const FJVideoRemoveBgCustomAfterContainer = () => {
    const dispatch = useDispatch();
    const editVideoInfo = useSelector(state => state.videoBgRemover.editVideoInfo);
    const customRemoverStatus = useSelector(state => state.videoBgRemover.customRemoverStatus);
    const isPlaying = useSelector(state => state.videoBgRemover.isPlaying);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);

    const initCanvas = useCallback(
        canvas => {
            dispatch(FJActionVideoRemoveBg.initCustomRemoverStep2CanvasAction(canvas));
        },
        [dispatch],
    );

    const pauseVideo = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.pauseAction());
    }, [dispatch]);

    const playVideo = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.playAction());
    }, [dispatch]);

    return (
        <>
            {customRemoverStatus === FJConstant.DEFAULT && headerTabIndex === 0 && (
                <FJVideoRemovePreviewBox
                    setCanvas={initCanvas}
                    editVideoInfo={editVideoInfo}
                    isRemoveBgAfter={true}
                    pauseVideo={pauseVideo}
                    isPlay={isPlaying}
                    playVideo={playVideo}
                />
            )}
        </>
    );
};

export default FJVideoRemoveBgCustomAfterContainer;
